import { useState, type FC } from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { ProgressSection } from './ProgressSection';
import { StatsGrid } from './StatsGrid';
import { SubtramiteList } from './SubtramiteList';
import { useTramiteStatusSummary } from './useTramiteStatusSummary';

export interface TramiteStatusSummaryProps {
  tramite: any;
}

const TramiteStatusSummary: FC<TramiteStatusSummaryProps> = ({ tramite }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    completed,
    totalEnabled,
    progressPercentage,
    stats,
    subtramites
  } = useTramiteStatusSummary(tramite);

  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 mb-6">
      {/* Vista compacta siempre visible */}
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-semibold text-gray-900">Estado de Subtrámites</h3>
        <div className="flex items-center gap-2">
          <Badge variant="outline" className="text-sm">
            {completed}/{totalEnabled} Finalizados
          </Badge>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            className="h-8 px-2"
          >
            {isExpanded ? (
              <>
                Ocultar <ChevronUp className="w-4 h-4 ml-1" />
              </>
            ) : (
              <>
                Ver detalle <ChevronDown className="w-4 h-4 ml-1" />
              </>
            )}
          </Button>
        </div>
      </div>

      {/* Progreso compacto */}
      <ProgressSection
        progressPercentage={progressPercentage}
      />

      {/* Vista expandida */}
      {isExpanded && (
        <div className="pt-4 mt-4">
          {/* Resumen compacto en una fila */}
          <StatsGrid stats={stats} />

          {/* Lista de subtrámites  */}
          <SubtramiteList tramite={tramite} subtramites={subtramites} />
        </div>
      )}
    </div>
  );
};

TramiteStatusSummary.displayName = 'TramiteStatusSummary';

export default TramiteStatusSummary;